var map = {
	"./007-microphone-1.png": 58703,
	"./010-home.png": 67952,
	"./013-document-1.png": 41345,
	"./014-document.png": 3534,
	"./015-color-palette.png": 35943,
	"./017-video-camera.png": 43291,
	"./024-like.svg": 81311,
	"./1.svg": 31866,
	"./155-credit-card.svg": 46589,
	"./2.svg": 99977,
	"./3.svg": 12088,
	"./4.svg": 84919,
	"./New Customer.svg": 1559,
	"./NotOpen.svg": 52092,
	"./Opened.svg": 19042,
	"./Profit.svg": 74968,
	"./SalesRevenue.svg": 26229,
	"./Sent.svg": 63687,
	"./Slack.svg": 4959,
	"./address.svg": 37683,
	"./adidas.svg": 88509,
	"./adobe.svg": 76894,
	"./arrow-growth.svg": 19688,
	"./arrow-left.png": 34666,
	"./arrow-left.svg": 40682,
	"./arrow-right.png": 52231,
	"./arrow-right.svg": 47969,
	"./bell.svg": 41478,
	"./book-open.svg": 35831,
	"./book.svg": 41986,
	"./briefcase.svg": 60019,
	"./camera.svg": 92076,
	"./chat.svg": 95455,
	"./check-circle.svg": 2436,
	"./clipboard.svg": 33313,
	"./clock.svg": 48493,
	"./cloud.svg": 1248,
	"./columns.svg": 98642,
	"./documentation.svg": 97309,
	"./dollar-circle.svg": 80092,
	"./envelope.svg": 24805,
	"./file.svg": 14671,
	"./flat.svg": 8908,
	"./google-customIcon.svg": 38363,
	"./google-plus.svg": 82421,
	"./headphone.svg": 51609,
	"./heart-fill.svg": 19359,
	"./home.svg": 31768,
	"./iconfinder_trello_2317760.svg": 41300,
	"./idea.svg": 38168,
	"./image.png": 38774,
	"./image.svg": 52576,
	"./label.png": 84307,
	"./layers.svg": 99487,
	"./left-bar.svg": 14302,
	"./left.svg": 3902,
	"./logo2.svg": 8502,
	"./logo3.svg": 55367,
	"./logo4.svg": 52968,
	"./logo5.svg": 65337,
	"./logo6.svg": 16042,
	"./logoIn.svg": 61825,
	"./message.svg": 37022,
	"./microsoft.svg": 84139,
	"./money-wave.svg": 43407,
	"./paint.svg": 99867,
	"./protection.svg": 64396,
	"./quote-left.png": 43719,
	"./quote-right.png": 98936,
	"./quote.png": 14873,
	"./repeat.svg": 17964,
	"./right.svg": 94045,
	"./setting.svg": 75467,
	"./shopping-cart.svg": 22552,
	"./speed-meter.svg": 65666,
	"./strategy.svg": 39882,
	"./theme.svg": 40484,
	"./ticket.svg": 47185,
	"./user.svg": 1080,
	"./users-alt.svg": 98565,
	"./water-fall.svg": 87168,
	"./wordpress.svg": 50634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66609;